const gsv = window.LOCAL_CONFIG.OMC_GSV
/**
 获取组织
 */
export function queryOrgs (option) {
  return window.fetch.post(gsv + '/getOrgListByPage', option)
}